import React from "react";
import { Swiper, SwiperSlide } from 'swiper/react';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/free-mode';
import 'swiper/css/navigation';
import { Autoplay, FreeMode, Navigation } from 'swiper/modules';
import mom1 from "../assets/images/mom1.png";
import mom2 from "../assets/images/mom2.png";
import mom3 from "../assets/images/mom3.png";
import mom4 from "../assets/images/mom4.png";
import mom5 from "../assets/images/mom5.png";

const WowMomenets = () => {

    const cityPackages = [
        { id: 1, imgUrl: mom1 },
        { id: 2, imgUrl: mom2 },
        { id: 3, imgUrl: mom3 },
        { id: 4, imgUrl: mom5 },
        { id: 5, imgUrl: mom4 },

    ];

    return (
        <>
            <section className="aboutSections bg-white my-5 mb-4" >
                <div className='row mx-0 align-items-center' >
                    <div className='col-lg-5'>
                        <div className='aboutleftcontain'>
                            <h4>Wow, you made it all the way here. Impressive! </h4>

                        </div>
                    </div>
                    <div className='col-lg-5 offset-lg-2'>
                        <div className='aboutrightcontain'>
                            <p>How about subscribing to our Instagram? You’ll get news, discounts, and other useful stuff</p>
                            <button className="btnbookprimary me-3">Follow us on Instagram</button>
                        </div>
                    </div>
                </div>
            </section>

            <div className="row mt-2 justify-content-center">
                <div className="col-lg-12 col-md-12">
                    <div className='customerReview m-0'>
                        <Swiper
                            freeMode={true}
                            autoplay={{
                                delay: 2500,
                                disableOnInteraction: false,
                            }}
                            breakpoints={{
                                1024: { slidesPerView: 4.5, spaceBetween: 30 },
                                768: { slidesPerView: 2.5, spaceBetween: 20 },
                                400: { slidesPerView: 1.5, spaceBetween: 10 },
                            }}
                            modules={[Autoplay, Navigation, FreeMode]}
                            className="mySwiper"
                        >
                            {cityPackages.map((city) => (
                                <SwiperSlide key={city.id}>
                                    <div className="citiesbox">

                                        <img src={city.imgUrl} alt="cities" />
                                    </div>
                                </SwiperSlide>
                            ))}
                        </Swiper>
                    </div>
                </div>
            </div>

        </>
    );
};

export default WowMomenets;
